/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agent_Triggers_Event_Backlog_HintInputs */



/**
* | output |
* | --- |
* | "New events are dropped until some of these runs finish or are approved." |
*
* @param {Agent_Triggers_Event_Backlog_HintInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_triggers_event_backlog_hint = /** @type {((inputs?: Agent_Triggers_Event_Backlog_HintInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Triggers_Event_Backlog_HintInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Neue Ereignisse werden verworfen, bis einige dieser Läufe abgeschlossen oder freigegeben sind.")
	return /** @type {LocalizedString} */ ("New events are dropped until some of these runs finish or are approved.")
});